import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'

type Tab = {
  label: string
  route: string
}
type Props = {
  tabs: Tab[]
}
const RouteTabs: React.FC<Props> = ({tabs}) => {
  const location = useLocation()

  return (
    <div className='d-flex overflow-auto h-55px'>
      <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
        {tabs.map((t: Tab, index: number) =>(
          <li className='nav-item' key={`tab-${index}`}>
            <Link
              className={
                `nav-link text-active-primary me-6 ` +
                (location.pathname === t.route && 'active')
              }
              to={t.route}
            >
              {t.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export {RouteTabs}
